import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { FeatureIcon } from "@/components/site/FeatureIcon";
import { Plus, Trash2, Save } from "lucide-react";

const ICON_OPTIONS = ["map", "route", "sparkles", "heart", "footprints", "camera", "download", "layers", "lock", "cloud", "shield", "compass"];

export default function FeaturesTab({ endpoint, title }) {
  const [items, setItems] = useState([]);
  const publicPath = endpoint === "features" ? "/features" : "/premium-features";

  const load = () => api.get(publicPath).then(({ data }) => setItems(data)).catch(() => {});
  useEffect(() => { load(); }, [endpoint]);

  const update = (id, patch) => setItems((arr) => arr.map((it) => (it.id === id ? { ...it, ...patch } : it)));

  const save = async (item) => {
    try {
      await api.put(`/admin/${endpoint}/${item.id}`, {
        title: item.title, description: item.description, icon: item.icon, highlight: item.highlight || "",
      });
      toast.success("Kart kaydedildi.");
    } catch { toast.error("Kaydedilemedi."); }
  };

  const add = async () => {
    try {
      const { data } = await api.post(`/admin/${endpoint}`, { title: "Yeni Kart", description: "Açıklama", icon: "sparkles", highlight: "" });
      setItems((arr) => [...arr, data]);
    } catch { toast.error("Eklenemedi."); }
  };

  const remove = async (id) => {
    try {
      await api.delete(`/admin/${endpoint}/${id}`);
      setItems((arr) => arr.filter((it) => it.id !== id));
      toast.success("Kart silindi.");
    } catch { toast.error("Silinemedi."); }
  };

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <h3 className="font-serif-display text-xl font-semibold text-[#1A251E]">{title}</h3>
        <button onClick={add} data-testid={`${endpoint}-add-btn`} className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-[#40916C] text-white text-sm font-semibold hover:bg-[#2D6A4F] transition-colors">
          <Plus className="h-4 w-4" /> Kart Ekle
        </button>
      </div>

      <div className="grid gap-4 lg:grid-cols-2">
        {items.map((it, i) => (
          <div key={it.id} data-testid={`${endpoint}-item-${i}`} className="rounded-2xl border border-[#E2E8E4] bg-white p-5 space-y-3">
            <div className="flex items-start gap-3">
              <div className="grid place-items-center h-11 w-11 shrink-0 rounded-xl bg-[#1B4D2E] text-[#D4AF37]">
                <FeatureIcon name={it.icon} className="h-5 w-5" />
              </div>
              <input value={it.title} onChange={(e) => update(it.id, { title: e.target.value })} className="sr-input" placeholder="Başlık" />
            </div>
            <textarea rows={2} value={it.description} onChange={(e) => update(it.id, { description: e.target.value })} className="sr-input resize-none" placeholder="Açıklama" />
            <div className="flex items-center gap-2 flex-wrap">
              <select value={it.icon} onChange={(e) => update(it.id, { icon: e.target.value })} className="sr-input !py-2 !w-auto">
                {ICON_OPTIONS.map((o) => <option key={o} value={o}>{o}</option>)}
              </select>
              <button onClick={() => save(it)} className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-[#0F2F1D] text-white text-sm font-medium hover:bg-[#1B4D2E]"><Save className="h-3.5 w-3.5" /> Kaydet</button>
              <button onClick={() => remove(it.id)} className="grid place-items-center h-9 w-9 rounded-full text-red-600 hover:bg-red-50"><Trash2 className="h-4 w-4" /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
